module.exports = {"name":"jon"}


//////////////////
// WEBPACK FOOTER
// ./src/initialState.json
// module id = 647
// module chunks = 0